import Vue from 'vue'
import VueRouter from 'vue-router'
import Acl from 'vue-acl'

Vue.use(VueRouter)
let router = new VueRouter({
  mode: 'history',

  routes: [
    // unauthenticated


    {
      name: 'login',
      path: '/',
      component: require('@components/views/login/login.vue').default,
      meta: { permission: 'any' }
    },

        // {
        // name: 'test1',
        // path: '/',
        // component: require('@components/views/test1.vue').default,
        // meta: { permission: 'any' }
        // },


    {
      name: 'registro',
      path: '/registro',
      component: require('@components/views/login/registro.vue').default,
      meta: { permission: 'any' },
      fail: '/'
    },

    {
      name: 'empresas',
      path: '/empresas',
      component: require('@components/views/preselect/empresas.vue').default,
      meta: { permission: 'any' },
      fail: '/'
    },



    // secured
    {
      name: 'home',
      path: '/home',
      component: require('@components/views/home/home.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarPedidoCat',
      path: '/RealizarPedidoCat',
      component: require('@components/views/realizarPedido/realizarPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarPedidoSubcat',
      path: '/RealizarPedidoSubcat',
      component: require('@components/views/realizarPedido/realizarPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarPedidoProd',
      path: '/RealizarPedidoProd',
      component: require('@components/views/realizarPedido/realizarPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },



    // nuevo
    {
      name: 'realizarDevolucionCat',
      path: '/RealizarDevolucionCat',
      component: require('@components/views/realizarDevolucion/realizarDevolucion.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarDevolucionSubcat',
      path: '/RealizarDevolucionSubcat',
      component: require('@components/views/realizarDevolucion/realizarDevolucion.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarDevolucionProd',
      path: '/RealizarDevolucionProd',
      component: require('@components/views/realizarDevolucion/realizarDevolucion.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },


    {
      name: 'realizarPresupuestoCat',
      path: '/RealizarPresupuestoCat',
      component: require('@components/views/realizarPresupuesto/realizarPresupuesto.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarPresupuestoSubcat',
      path: '/RealizarPresupuestoSubcat',
      component: require('@components/views/realizarPresupuesto/realizarPresupuesto.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'realizarPresupuestoProd',
      path: '/RealizarPresupuestoProd',
      component: require('@components/views/realizarPresupuesto/realizarPresupuesto.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },
 // nuevo





    {
      name: 'pedido',
      path: '/Pedido',
      component: require('@components/views/pedido/pedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'estadoPedido',
      path: '/EstadoPedido',
      component: require('@components/views/estadoPedido/estadoPedido.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'pedidoCms',
      path: '/PedidoCms',
      component: require('@components/views/estadoPedido/pedidoCms.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'promociones',
      path: '/Combos',
      component: require('@components/views/promociones/promociones.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'descuentos',
      path: '/Descuentos',
      component: require('@components/views/descuentos/descuentos.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'devoluciones',
      path: '/Devoluciones',
      component: require('@components/views/devoluciones/devolucion.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'presupuestos',
      path: '/Presupuestos',
      component: require('@components/views/presupuestos/presupuesto.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'estadoPresupuesto',
      path: '/EstadoPresupuesto',
      component: require('@components/views/estadoPresupuesto/estadoPresupuesto.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },


    {
      name: 'estadoDevolucion',
      path: '/EstadoDevolucion',
      component: require('@components/views/estadoDevolucion/estadoDevolucion.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'presupuestoCms',
      path: '/PresupuestoCms',
      component: require('@components/views/estadoPresupuesto/presupuestoCms.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

    {
      name: 'devolucionCms',
      path: '/DevolucionCms',
      component: require('@components/views/estadoDevolucion/DevolucionCms.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },


    {
      name: 'reload',
      path: '/reload',
      component: require('@components/views/pedido/reload.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
    },

     {
      name: 'ctacte',
      path: '/ctacte',
      component: require('@components/views/ctacte/index.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
     },

     {
      name: 'clientes',
      path: '/clientes',
      component: require('@components/views/preselect/clientes.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
     },

     {
      name: 'altaClientes',
      path: '/altaClientes',
      component: require('@components/views/preselect/altaClientes.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
     },



     {
      name: 'configuracion',
      path: '/configuracion',
      component: require('@components/views/home/configuracion.vue').default,
      meta: { permission: 'user|seller' },
      fail: '/'
     },
     

    // {
    //   path: '',
    //   component: require('@components/layouts/root.vue').default,
    //   meta: { permission: 'user' },
    //   children: [
    //     // outside a project
    //     {
    //       path: '',
    //       component: require('@components/layouts/outside.vue').default,
    //       children: []
    //     },

    //     // inside a project
    //     {
    //       path: '',
    //       component: require('@components/layouts/inside.vue').default,
    //       children: []
    //     }
    //   ]
    // }

    
  ]
})

Vue.use(Acl, {
  router,
  init: 'any'
})

export default router



// WEBPACK FOOTER //
// ./src/config/router.js